import createReducer from 'utils/redux/createReducer'
import combineReducers from 'utils/redux/combineReducers'

// const initialState = {
//     property: {
//         predefined: 'All Properties'
//       , custom: null
//       , menu: false
//     }
//   , project: {
// 		predefined: 'Open Projects'
// 	  , custom: null
// 	  , menu: false
//   }
//   , transaction: {
// 		predefined: 'All Transactions'
// 	  , custom: null
// 	  , menu: false
//   }
// }
//
// let setFilter = (currentState, action) => ({//FILTER_REPLACE
// 	...currentState
//   , [action.data.entity]: {
// 		...currentState[action.data.entity]
// 	  , custom: null
// 	  , predefined: action.data.predefined
// 	}
// })
//
// export default createReducer(initialState, {
//   	PREDEFINED_FILTER_SET: setFilter
//   , OPEN_PREFILTERED: setFilter
// })
//
//

let filterReducer = (entity, initialState) => {
    let setFilter = (state, action) => (
         action.data.entity == entity ? action.data.predefined : state
    )
    return createReducer(initialState, {
      	PREDEFINED_FILTER_SET: setFilter
      , OPEN_PREFILTERED: setFilter
    })
}
export default combineReducers({
    property: filterReducer('property', 'All Properties')
  , project: filterReducer('project', 'All Projects')
  , transaction: filterReducer('transaction', 'All Transactions')
  , task: filterReducer('task', 'All Tasks')
  , tenant: filterReducer('tenant', 'Tenants')
  , lease: filterReducer('lease', 'Active Leases')
})



// WEBPACK FOOTER //
// ./src/reducers/filters.js